import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MatchService } from '../match.service';
import { MY_MATCH_QUERY_KEY } from '../queries/match';

/** Envia as respostas do match (usuário logado). Erros são tratados pela página. */
export const useSubmitMatchAnswer = (
	onSuccess?: (result: Match.Result) => void,
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (body: Match.SubmitAnswer) =>
			MatchService.submitAnswer(body),
		onSuccess: (result) => {
			queryClient.setQueryData<Match.MyMatch>(MY_MATCH_QUERY_KEY, {
				answered: true,
				answer: null,
				result,
			});
			if (onSuccess) onSuccess(result);
		},
	});
};

/** Admin: simulação do match. Não invalida nada — nenhuma resposta é gravada. */
export const useSimulateMatch = () =>
	useMutation({
		mutationFn: (body: Match.SubmitAnswer) => MatchService.simulate(body),
	});
